<mat-divider></mat-divider>
<footer>&copy; 2020 All Right Reserved</footer>